// Адрес сервиса FAKT Support: один на все бренды. Переопределение - VUE_APP_SUPPORT_URL
// (.env.dev_local для локального стенда, например http://localhost:8090).
export const SUPPORT_URL = (process.env.VUE_APP_SUPPORT_URL || 'https://support.fakt-crm.ru').replace(/\/$/, '')
export const SUPPORT_API_URL = `${SUPPORT_URL}/api/crm`
export const SUPPORT_WIDGET_URL = `${SUPPORT_URL}/widget/widget.js`

// ВРЕМЕННО (раскатка FAKT Support по филиалам). Поддержка показывается только в филиалах из
// VUE_APP_SUPPORT_BRANCH_IDS - ID филиалов CRM через запятую, например `3,17`. Пусто, не задано или
// только мусор - ограничения нет, поддержка во всех филиалах. Снять, когда поддержка раскатана на все
// филиалы: этот блок, геттер support/enabled и его условия (App.vue, SupportWidget.vue, ProfileDrawer.vue,
// router/routes/support.js, NotificationButton.vue), ключ в .env.* (tech-debt/2026-10-12-support-branch-whitelist.md).
export function parseBranchIds (raw) {
  const ids = String(raw ?? '')
    .split(',')
    .map(item => Number(item.trim()))
    .filter(id => Number.isInteger(id) && id > 0)

  return ids.length ? new Set(ids) : null
}

/** null - ограничения нет; иначе Set ID филиалов, где поддержка включена. */
export const SUPPORT_BRANCH_IDS = parseBranchIds(process.env.VUE_APP_SUPPORT_BRANCH_IDS)

// Кнопка чата виджета: круг 60 в правом нижнем углу с отступом 24 (макет c01, fakt-support
// src/widget/components/ChatButton.vue).
// Плавающие кнопки CRM встают над ней и выравниваются по её правому краю.
export const CHAT_BUTTON = { size: 60, offset: 24 }
